import brand from '@helpers/brand';
import { SystemIcon, getSvgFromSystem } from '@helpers/systemIcons';
import { withMotion } from '@hoc/withMotion';
import React from 'react';
import S from './Filter.styles';
const Filter = ({ activeFilter, checkboxFilters, itemAmount, dropdownFilter, dropdownFilterValue, filterOpen, filterHeading, searchTerm, translations, setFilterOpen, onCheckboxChange, onReset, keywordSearchHandler, }) => {
    const ref = React.useRef(null);
    const [activeId, setActiveId] = React.useState('');
    const [tempSearchTerm, setTempSearchTerm] = React.useState(searchTerm ?? '');
    return (React.createElement(S.Container, { "aria-active": filterOpen },
        React.createElement(S.Overlay, { ref: ref },
            React.createElement(S.Title, null, filterHeading),
            React.createElement(S.FilterList, null,
                React.createElement(S.CheckboxFilterHolder, null,
                    React.createElement(S.FilterHolder, null,
                        React.createElement(S.FilterSearch, { id: "keywordSearch", placeholder: translations['translations.search.search-placholder'] ?? 'Keyword search', value: tempSearchTerm ? tempSearchTerm : '', onChange: (event) => setTempSearchTerm(event.target.value), onKeyDown: (event) => {
                                if (event.key !== 'Enter') {
                                    return;
                                }
                                else {
                                    keywordSearchHandler(tempSearchTerm);
                                }
                            } })),
                    checkboxFilters?.length > 0 &&
                        checkboxFilters.map((filter) => (React.createElement(S.FilterHolder, { key: filter.key, animate: activeId === filter.key ? 'open' : 'closed', initial: activeId === filter.key ? 'open' : 'closed' },
                            React.createElement(S.FilterBtn, { type: "button", active: activeId === filter.key, onClick: () => {
                                    if (activeId === filter.key) {
                                        setActiveId('');
                                    }
                                    else {
                                        setActiveId(filter.key ?? '');
                                    }
                                } },
                                filter.filterTitle,
                                React.createElement(S.FilterBtnIcon, null, getSvgFromSystem(SystemIcon.HoverArrowDown))),
                            React.createElement(S.FilterOptions, { variants: {
                                    open: {
                                        height: 'auto',
                                        outline: `1px solid ${brand.black}`,
                                    },
                                    closed: {
                                        height: 0,
                                        outline: 0,
                                    },
                                }, transition: { ease: 'linear', duration: 0.2 } }, filter.options.map((checkbox) => {
                                const selectedOption = dropdownFilterValue.includes(checkbox.value);
                                return (React.createElement(S.Checkbox, { key: checkbox.id },
                                    React.createElement(S.ItemContainer, null,
                                        React.createElement(S.CheckboxInput, { type: "checkbox", id: `${filter.key}-${checkbox.value}`, checked: selectedOption, name: filter.key, value: checkbox.value, onChange: () => onCheckboxChange(filter.key, checkbox.value) }),
                                        React.createElement(S.CheckboxLabel, { htmlFor: `${filter.key}-${checkbox.value}` },
                                            checkbox.text,
                                            React.createElement(S.Tick, null)))));
                            })))))),
                dropdownFilter && (React.createElement(React.Fragment, null, dropdownFilterValue &&
                    onCheckboxChange &&
                    dropdownFilter?.map((filter) => (React.createElement(S.FilterHolder, { key: filter.key, animate: activeId === filter.key ? 'open' : 'closed', initial: activeId === filter.key ? 'open' : 'closed' },
                        React.createElement(S.FilterBtn, { type: "button", active: activeId === filter.key, onClick: () => {
                                if (activeId === filter.key) {
                                    setActiveId('');
                                }
                                else {
                                    setActiveId(filter.key ?? '');
                                }
                            } },
                            filter.title,
                            getSvgFromSystem(SystemIcon.HoverArrowDown)),
                        React.createElement(S.FilterOptions, { variants: {
                                open: {
                                    height: 'auto',
                                },
                                closed: {
                                    height: 0,
                                },
                            }, transition: { ease: 'linear', duration: 0.2 } }, filter.options?.length > 0 && (React.createElement(S.Filter, null,
                            React.createElement(S.SelectLabel, { htmlFor: filter.key },
                                translations['translations.search.filter-by'] ?? 'Filter by',
                                ' ',
                                filter.title),
                            React.createElement(S.FilterDropdown, { id: filter.key, name: filter.key, value: filter.key ?? '', onChange: (event) => onCheckboxChange(filter.key, event.target.value, true) },
                                React.createElement("option", { value: "" }, filter.title),
                                filter.options.map((option) => (React.createElement("option", { key: option.id, value: option.value }, option.text)))))))))))))),
        (activeFilter.length > 0 || (searchTerm && searchTerm.length > 0)) && (React.createElement(S.TotalResults, null,
            itemAmount,
            " ",
            translations['translations.search.results-found'] ?? 'Results found')),
        React.createElement(S.ActiveFilters, null,
            checkboxFilters?.map((filter) => activeFilter &&
                activeFilter.map((item) => filter.options.map((option) => {
                    if (item === option.value) {
                        return (React.createElement(S.ActiveTab, { key: item, type: "button", title: option.text, styleType: "solid", addon: getSvgFromSystem(SystemIcon.Cross), onClick: () => onCheckboxChange(filter.key, item, false, true) }));
                    }
                }))),
            dropdownFilter?.map((filter) => activeFilter &&
                activeFilter.map((item) => filter.options.map((option) => {
                    if (item === option.value) {
                        return (React.createElement(S.ActiveTab, { key: item, type: "button", title: option.text, styleType: "solid", onClick: () => onCheckboxChange(filter.key, item, false, true) }));
                    }
                }))),
            activeFilter && activeFilter?.length > 0 && (React.createElement(S.ActiveTab, { type: "button", title: translations['translations.search.clear-all'], styleType: "solid", addon: getSvgFromSystem(SystemIcon.Cross), onClick: onReset }))),
        React.createElement(S.Background, { onClick: (event) => {
                event.preventDefault();
                setFilterOpen && setFilterOpen(false);
            } })));
};
export default withMotion(Filter);
